import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "8", cy: "9", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M8 21h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 17v4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Wallpaper";
const Wallpaper = memo(themed(Icon));
export {
  Wallpaper
};
//# sourceMappingURL=wallpaper.js.map
